import React from 'react'
import { motion } from 'framer-motion'
import { FaPlay } from 'react-icons/fa'

const DemoSection = () => {
  return (
    <section className="section-padding bg-white">
      <div className="container-max">
        <motion.div 
          className="text-center mb-12"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Découvrez EMDR Plus en action
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Voyez comment notre outil facilite la pratique de l'EMDR en 2 minutes
          </p>
        </motion.div>

        <motion.div
          className="max-w-4xl mx-auto"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <div className="relative bg-gray-900 rounded-2xl overflow-hidden shadow-2xl">
            <video 
              className="w-full aspect-video object-cover"
              poster="/images/demo-thumbnail.png"
              controls
              preload="metadata"
            >
              <source src="/demo EMDR Flow 01.mp4" type="video/mp4" />
              Votre navigateur ne supporte pas la lecture vidéo.
            </video>
          </div>
          
        </motion.div>
      </div>
    </section>
  )
}

export default DemoSection 